export enum UnitOfMeasure {
    PIECE,
    KILOGRAM,
    TON,
    KWH,
    DAY,
    HOUR,
    MINUTE,
    MONTH,
    LITER,
    KILOMETER,
    CUBIC_METER,
    METER,
    LINEAR_METER,
    CARTON,
    PACK,
    OWN
}